// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"4f034e44","281":"4f034e44"}[chunkId] + ".css";
};